/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedModelEntityModelDeviceEventDto } from '../models/PagedModelEntityModelDeviceEventDto';
import type { PagedResourcesAssemblerDeviceEventDto } from '../models/PagedResourcesAssemblerDeviceEventDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CareAdminDeviceEventControllerService {
    /**
     * @returns PagedModelEntityModelDeviceEventDto OK
     * @throws ApiError
     */
    public static list({
        deviceId,
        assembler,
        page,
        size = 20,
        sort,
    }: {
        deviceId: number,
        assembler: PagedResourcesAssemblerDeviceEventDto,
        /**
         * Zero-based page index (0..N)
         */
        page?: number,
        /**
         * The size of the page to be returned
         */
        size?: number,
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>,
    }): CancelablePromise<PagedModelEntityModelDeviceEventDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/care/devices/{deviceId}/events',
            path: {
                'deviceId': deviceId,
            },
            query: {
                'page': page,
                'size': size,
                'sort': sort,
                'assembler': assembler,
            },
        });
    }
}
